import React, { useEffect } from 'react';
import { useWebView } from '@mp';
import { Box } from '@medely/ui-kit';
import { PhoneScreeningSchedulerForm } from '@mp/components/calendlyModal/PhoneSchedulerForm.web';

const ReScreeningSchedulerEmbedded = () => {
  const { setIsWebView } = useWebView();

  useEffect(() => {
    setIsWebView(true);
  }, []);

  return (
    <Box p={1}>
      <PhoneScreeningSchedulerForm />
    </Box>
  );
};

export default ReScreeningSchedulerEmbedded;
